var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.699 7.284L14.707.293l-.031-.028-.04-.037-.03-.022-.05-.037-.023-.014a1.024 1.024 0 00-.06-.036L14.454.11a1 1 0 00-.072-.034l-.011-.004a.985.985 0 00-.08-.029c-.005 0-.009-.002-.012-.003a.993.993 0 00-.083-.02L14.17.016A.989.989 0 0014 0H1.999a2.002 2.002 0 00-2 2v22a2.002 2.002 0 002 2H20a2.002 2.002 0 002-2V8.02l.001-.02a.995.995 0 00-.302-.716zM15 19H7a1 1 0 010-2h8a1 1 0 010 2zm0-4H7a1 1 0 010-2h8a1 1 0 010 2zm-1-7V2.414L19.586 8H14z",
    fill: "#33647E"
  })));
}
export default SvgDocumentFilled;